import { render, staticRenderFns } from "./DappsHeader.vue?vue&type=template&id=7ca9b27e&scoped=true"
import script from "./DappsHeader.vue?vue&type=script&lang=ts"
export * from "./DappsHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca9b27e",
  null
  
)

export default component.exports